import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BoltIconDesktop = (props: SvgProps) => (
  <Svg width={24} height={24} fill="none" {...props}>
    <Path
      d="M13 2 3 14h9l-1 8 10-12h-9l1-8Z"
      stroke={props.color ?? '#3379BD'}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default BoltIconDesktop;
